import { merge, Observable } from 'rxjs'

import { crossTabAuth$ } from './auth'
import { crossTabCart$ } from './cart'
import { crossTabDispensary$ } from './dispensary'

export type { CrossTabEnvelope, CrossTabMessage } from './channel'
export { crossTabChannel } from './channel'

/** Root subscription for every cross-tab consumer; held by `GlobalSubscriptions`. */
export const crossTabSync$: Observable<unknown> = merge(
  crossTabAuth$,
  crossTabCart$,
  crossTabDispensary$,
)
